/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLeadBrokerListItemDto } from './GetLeadBrokerListItemDto';
import {
    GetLeadBrokerListItemDtoFromJSON,
    GetLeadBrokerListItemDtoFromJSONTyped,
    GetLeadBrokerListItemDtoToJSON,
    GetLeadBrokerListItemDtoToJSONTyped,
} from './GetLeadBrokerListItemDto';

/**
 * 
 * @export
 * @interface GetLeadBrokerListResponse
 */
export interface GetLeadBrokerListResponse {
    /**
     * Total number of brokers matching the search criteria
     * @type {number}
     * @memberof GetLeadBrokerListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<GetLeadBrokerListItemDto>}
     * @memberof GetLeadBrokerListResponse
     */
    items: Array<GetLeadBrokerListItemDto>;
}

/**
 * Check if a given object implements the GetLeadBrokerListResponse interface.
 */
export function instanceOfGetLeadBrokerListResponse(value: object): value is GetLeadBrokerListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetLeadBrokerListResponseFromJSON(json: any): GetLeadBrokerListResponse {
    return GetLeadBrokerListResponseFromJSONTyped(json, false);
}

export function GetLeadBrokerListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadBrokerListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(GetLeadBrokerListItemDtoFromJSON)),
    };
}

export function GetLeadBrokerListResponseToJSON(json: any): GetLeadBrokerListResponse {
    return GetLeadBrokerListResponseToJSONTyped(json, false);
}

export function GetLeadBrokerListResponseToJSONTyped(value?: GetLeadBrokerListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(GetLeadBrokerListItemDtoToJSON)),
    };
}

